<template>
  <div class="tw-w-full" :class="largeWidth ? 'tw-max-w-lg' : ''">
    <label
      v-if="label"
      :for="id"
      class="tw-block tw-mb-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500"
    >
      {{ label }}
    </label>

    <div v-if="type === 'checkbox'" class="tw-flex tw-items-center tw-gap-2">
      <input
        :checked="!!modelValue"
        @change="updateInput"
        type="checkbox"
        :id="id"
        class="tw-h-4 tw-w-4 tw-rounded tw-border-slate-300 tw-text-slate-900 focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55"
      />
      <span v-if="placeholder" class="tw-text-sm tw-text-slate-700">{{ placeholder }}</span>
    </div>

    <textarea
      v-else-if="type === 'textarea'"
      :value="modelValue"
      @input="updateInput"
      :id="id"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      class="tw-w-full tw-min-h-[120px] tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 tw-transition placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55"
    />

    <input
      v-else
      :value="modelValue"
      @input="updateInput"
      :type="type"
      :id="id"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      class="tw-w-full tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 tw-transition placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InputField',
  props: {
    id: String,
    placeholder: String,
    modelValue: [String, Number, Boolean],
    label: {
      type: [String, Number],
      default: undefined,
    },
    isInput: {
      default: true,
    },
    enableCancel: {
      default: false,
    },
    largeWidth: {
      default: false,
    },
    type: {
      default: 'text',
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue(val) {
      if (this.type === 'number') {
        let outnum = val;
        if (this.$options.filters && this.$options.filters.handleEmptyNumber) {
           outnum = this.$options.filters.handleEmptyNumber(val);
        } else if (val === '') {
           outnum = 0;
        }

        this.$emit('update:modelValue', outnum);
      }
    },
  },
  methods: {
    updateInput(event) {
      if (this.isInput) {
        if (this.type === 'checkbox') {
          this.$emit('update:modelValue', !!event.target.checked);
        } else {
          this.$emit('update:modelValue', event.target.value);
        }
      } else {
        this.$emit('update:modelValue', event);
      }
    },
    cancelInput() {
      this.$emit('update:modelValue', '');
    },
  },
});
</script>